<div class="popup__text">
  <ng-content></ng-content>
</div>
<e-divider *ngIf="!noDivider"></e-divider>
